export enum LanguageSimple {
    En,
    Ru,
}

export const LanguageSimpleNames: { [p: string]: string } = {
    [LanguageSimple[LanguageSimple.Ru]]: 'Ru',
    [LanguageSimple[LanguageSimple.En]]: 'En',
};
